var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSummary)?_c('div',[_c('span',{staticClass:"d-flex align-items-center"},[_vm._v(" Mejor calificación: "),_c('EvaluationGrade',{staticClass:"ms-2",attrs:{"grade":_vm.summary?.higher?.note}}),_vm._v(", obtenida el: "+_vm._s(_vm.date)+" ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }